"use client";
import * as React from "react";

export const NavContext = React.createContext<{
  handleCloseMenu: () => void;
}>({
  handleCloseMenu: () => undefined
});
